import type { Policy, PolicyColumn } from '../types/policy.type';

export const POLICY_LIST_PAGE_SIZE = 10;
export const POLICY_LIST_FIRST_PAGE = 1;

export const POLICY_TEXTS = {
  TITLE: 'Políticas',
  SEARCH_PLACEHOLDER: 'Buscar',
  SEARCH_LABEL: 'Buscar política',
  CREATE_BUTTON: 'Crear política',
  NO_REVIEW_FLOW: 'Sin flujo',
  EMPTY_TITLE: 'Crea tu primera política',
  EMPTY_BODY:
    'Aún no tienes políticas creadas. Crea una para comenzar a gestionarlas desde aquí.',
  NO_RESULTS: 'No encontramos políticas con ese nombre',
  LOADING: 'Cargando políticas…',
  ERROR: 'No pudimos cargar tus políticas. Inténtalo de nuevo.',
  RETRY: 'Reintentar',
  ROW_ACTIONS: 'Acciones de la política',
} as const;

export const POLICY_TABLE_COLUMNS: Array<PolicyColumn> = [
  { key: 'name', label: 'Nombre' },
  { key: 'usersCount', label: 'No. de usuarios' },
  { key: 'reviewFlowName', label: 'Flujo de revisión' },
  { key: 'version', label: 'Versión' },
];

export const POLICY_SAMPLE_LIST: Array<Policy> = [
  { id: 'policy-01', name: 'Viajes nacionales', usersCount: 24, reviewFlowName: 'Aprobación jefe directo', version: '1.0.0' },
  { id: 'policy-02', name: 'Viajes internacionales', usersCount: 12, reviewFlowName: 'Aprobación gerencia', version: '1.0.0' },
  { id: 'policy-03', name: 'Alimentación y representación', usersCount: 38, reviewFlowName: 'Aprobación jefe directo', version: '1.0.0' },
  { id: 'policy-04', name: 'Transporte y movilidad', usersCount: 45, reviewFlowName: null, version: '1.0.0' },
  { id: 'policy-05', name: 'Hospedaje', usersCount: 18, reviewFlowName: 'Aprobación gerencia', version: '1.0.0' },
  { id: 'policy-06', name: 'Compras de oficina', usersCount: 9, reviewFlowName: 'Revisión de finanzas', version: '1.0.0' },
  { id: 'policy-07', name: 'Capacitación y eventos', usersCount: 15, reviewFlowName: 'Aprobación recursos humanos', version: '1.0.0' },
  { id: 'policy-08', name: 'Software y suscripciones', usersCount: 31, reviewFlowName: 'Revisión de tecnología', version: '1.0.0' },
  { id: 'policy-09', name: 'Marketing y publicidad', usersCount: 7, reviewFlowName: 'Aprobación gerencia', version: '1.0.0' },
  { id: 'policy-10', name: 'Atención a clientes', usersCount: 21, reviewFlowName: 'Aprobación jefe directo', version: '1.0.0' },
  { id: 'policy-11', name: 'Gastos de flota', usersCount: 5, reviewFlowName: 'Revisión de finanzas', version: '1.0.0' },
  { id: 'policy-12', name: 'Mantenimiento de instalaciones', usersCount: 11, reviewFlowName: 'Revisión de operaciones', version: '1.0.0' },
  { id: 'policy-13', name: 'Telefonía e internet', usersCount: 27, reviewFlowName: null, version: '1.0.0' },
  { id: 'policy-14', name: 'Reembolsos de caja chica', usersCount: 14, reviewFlowName: 'Revisión de finanzas', version: '1.0.0' },
  { id: 'policy-15', name: 'Viáticos de campo', usersCount: 33, reviewFlowName: 'Aprobación jefe directo', version: '1.0.0' },
];
